import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.iraq-parts.com/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Products
export const productService = {
  getAll: () => api.get('/products'),
  getById: (id) => api.get(`/products/${id}`),
  search: (query) => api.get(`/products/search?q=${query}`),
  getByCategory: (categoryId) => api.get(`/products/category/${categoryId}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`)
};

// Categories
export const categoryService = {
  getAll: () => api.get('/categories'),
  getById: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  delete: (id) => api.delete(`/categories/${id}`)
};

// Users/Auth
export const authService = {
  register: (data) => api.post('/users/register', data),
  login: (data) => api.post('/users/login', data),
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

// Orders
export const orderService = {
  create: (data) => api.post('/orders', data),
  createGuest: (data) => api.post('/orders/guest', data),
  getMyOrders: () => api.get('/orders/my-orders'),
  getById: (id) => api.get(`/orders/${id}`),
  searchByCodeAndPhone: (orderCode, phone) => api.post('/orders/search', { order_code: orderCode, phone }),
  getAll: () => api.get('/orders/admin/all'),
  getAdminById: (id) => api.get(`/orders/admin/${id}`),
  updateStatus: (id, status) => api.put(`/orders/${id}/status`, { status }),
  updateOrderItems: (id, data) => api.put(`/orders/admin/${id}/items`, data)
};

// Car Brands
export const carBrandService = {
  getAll: () => api.get('/car-brands'),
  getById: (id) => api.get(`/car-brands/${id}`),
  create: (data) => api.post('/car-brands', data),
  update: (id, data) => api.put(`/car-brands/${id}`, data),
  delete: (id) => api.delete(`/car-brands/${id}`)
};

// Car Models
export const carModelService = {
  getAll: (brandId) => api.get(`/car-models${brandId ? `?brand_id=${brandId}` : ''}`),
  getById: (id) => api.get(`/car-models/${id}`),
  create: (data) => api.post('/car-models', data),
  createWithImage: (formData) => api.post('/car-models', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, data) => api.put(`/car-models/${id}`, data),
  updateWithImage: (id, formData) => api.put(`/car-models/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/car-models/${id}`)
};

// Car Years
export const carYearService = {
  getAll: () => api.get('/car-years'),
  getById: (id) => api.get(`/car-years/${id}`),
  create: (data) => api.post('/car-years', data),
  update: (id, data) => api.put(`/car-years/${id}`, data),
  delete: (id) => api.delete(`/car-years/${id}`)
};

// Suppliers
export const supplierService = {
  getAll: () => api.get('/suppliers'),
  getById: (id) => api.get(`/suppliers/${id}`),
  create: (data) => api.post('/suppliers', data),
  update: (id, data) => api.put(`/suppliers/${id}`, data),
  delete: (id) => api.delete(`/suppliers/${id}`)
};

export default api;
